/** Data mínima (YYYY-MM-DD) para elegibilidade do badge «NOVO». */
export const NEW_PRODUCT_SINCE_DATE = '2026-09-15';

/** Janela em dias após created_at. */
export const NEW_PRODUCT_DAYS = 21;

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * @param {unknown} raw
 * @returns {number|null} epoch ms
 */
export function productCreatedAtMs(raw) {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (!s) return null;
  const normalized = s.includes('T') ? s : s.replace(' ', 'T');
  const ms = Date.parse(normalized);
  return Number.isFinite(ms) ? ms : null;
}

/**
 * Produto «novo»: created_at na ou após 15/09/2026 e com menos de 21 dias.
 *
 * @param {Record<string, unknown>|null|undefined} p
 * @param {number} [nowMs]
 */
export function productIsNew(p, nowMs = Date.now()) {
  if (!p || typeof p !== 'object') return false;
  const created = productCreatedAtMs(p.created_at);
  if (created === null) return false;

  const day = String(p.created_at).trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day) || day < NEW_PRODUCT_SINCE_DATE) {
    return false;
  }

  const age = nowMs - created;
  if (age < 0) return false;
  return age < NEW_PRODUCT_DAYS * DAY_MS;
}
